export const PRICE_CONST = {
  purchaseStatus : {
    PURCHASE            : 'PURCHASE',
    PURCHASE_ADDITIONAL : 'PURCHASE_ADDITIONAL',
    PURCHASE_RETURNS    : 'PURCHASE_RETURNS'
  }
}

export const SESSIONSTORAGE_KEY = {
  Coupon : {
    share  : 'CouponShare',
  }
}

export const coinDecimal = [
    {
      key     : 0,
      value   : 'free',
      decimal : 0
    },
    {
      key     : 101,
      value   : 'BTC',
      decimal : 4
    },
    {
      key     : 102,
      value   : 'ETH',
      decimal : 3
    },
    {
      key      : 103,
      value    : 'XRP',
      decimal  : 0
    },
    {
      key     : 104,
      value   : 'USDT',
      decimal : 1
    },
    {
      key      : 113,
      value    : 'POINT',
      decimal  : 0 // 확인필요
    }
]

export const subscribeType = {
  plan99  : 'Plan 99',
  plan199 : 'Plan 199',
  plan299 : 'Plan 299',
}

export const PROFIT_IAMGE_EDIT = "0";
export const PROFIT_IAMGE_DEL  = "1";

export const CHART_SUBSCRIBE_TYPE_PLAN_299 = 'plan299';
export const CHART_SUBSCRIBE_TYPE_PLAN_3999 = 'plan3999';

export const STORE_TYPE_NORMAL  = "0";
export const STORE_TYPE_GENERAL = "901";
export const STORE_TYPE_STAR    = "902";
export const STORE_TYPE_PLANET  = "903";

export const TREE_TYPE_CUSTOMER     = "customer";
export const TREE_TYPE_CUSTOMER_SUB = "customer_sub";
export const TREE_TYPE_PLANET       = "planet";
export const TREE_TYPE_PLANET_SUB   = "planet_sub";

export const STORE_PLANET_SETTING_STATE = "isPlanetSettingSaved";

export const STORE_TYPES = {
  0   : "NORMAL" ,
  901 : "GENERAL",
  902 : "STAR",
  903 : "PLANET",
}

export const baseUrl = 'https://api.risingx.co.kr';